import { ObjectHelper } from 'Code/Helpers/ObjectHelper';

export class IsVisibleOnFilterCountBaseValueConverter {
    toView(array) {
        let result = array.filter((item) => item.hasOwnProperty('IsVisibleOnFilter') && item['IsVisibleOnFilter'] == true);
        return ObjectHelper.IsNullOrUndefined(result) ? 0 : result.length;
    }
}